import {Mocks} from 'config/mocks';
import {isDevelopmentMode, isNetlifyOrAwsMode, PrototypeMode, StaticConfig} from 'config/staticConfig';
import {getValuesByKey} from 'utils/types';

export const areMocksEnabled = () =>
  Object.keys(Mocks).some((key) => key !== 'Enabled' && getValuesByKey(Mocks, key) === true);

export const isMenuDismissed = () => sessionStorage.getItem('DevInfoDismissed');

export const setMenuDismissed = () => {
  sessionStorage.setItem('DevInfoDismissed', 'go away');
};

export const showDevInfo =
  isDevelopmentMode || (isNetlifyOrAwsMode && StaticConfig.prototypeMode === PrototypeMode.NONE);
